<template>
   <div class="Account">
      <div class="board">
        <Checkout :currentOrg="currentOrg" :modelsTotal="modelsTotal" :paymentType="paymentType" :sessionState="sessionState" v-if="stepId === 'checkout'" />
        
        
         <div class="columns">
            <div class="column is-2">
               <b-menu>
                  <b-menu-list label="Account">
                     <b-menu-item v-for="item in items.filter( f => !hidden.includes(f.id))" :key="item.id" 
                      
                      :label="item.name" 
                      :active="stepId === item.id"
                      tag="router-link"
                      :to="'/account/'+item.id">
                      {{ item.id }} {{ stepId }}
                     </b-menu-item>
                     
                  </b-menu-list>
                </b-menu>
            </div>
            <div class="column">
               <div class="" >
                 <Usage :currentOrg="currentOrg" :modelsTotal="modelsTotal" :projectsTotal="projectsTotal" :usage="usage"  v-if="stepId == 'usage'" />
                 <Settings :currentUser="currentUser" :currentOrg="currentOrg" :modelsTotal="modelsTotal" :datasetsTotal="datasetsTotal" v-if="stepId == 'settings'" />
                
               </div>
            </div>
         </div>
      </div>
   </div>
</template>


<script>
import Settings from "@/dashboard/Account/Settings.vue";
import Checkout from "@/dashboard/Account/Checkout.vue";
import Usage from "@/dashboard/Account/Usage.vue";

export default {
  props: ["stepId", "sessionState", "paymentType"],
  name: "Account",
  data() {
    return {
      hidden: ['checkout'],
      items: [
          {
            name: "Plan", id: "usage"
          },
          {
             name: "Checkout", id: "checkout"
          },
          {
            name: "Settings", id: "settings"
          }
      ]
    }
  },
  components: {
    Settings,
    Checkout,
    Usage
  },
  computed: {
    currentUser() {
      return this.$store.state.currentUser;
    },
    currentOrg() {
      return this.$store.state.currentOrg;
    },
    modelsTotal() {
      return this.$store.state.models.length
    },
    projectsTotal() {
      return this.$store.state.projects.length
    },
    usage() {
        return this.$store.state.usage
    }
  },
  mounted() {
    this.$store.dispatch("currentUser")
  },
  created() {
    this.$store.dispatch("currentUser").then( () => {
        const organizationId = (this.currentUser.organizationId ? this.currentUser.organizationId : this.currentUser.id)
        this.$store.dispatch("currentOrg", organizationId);
        this.$store.dispatch("usage", organizationId);
    })


    this.$store.dispatch("retrieveAllModels");
    this.$store.dispatch("retrieveAllProjects");
    
  },

}

</script>